<template>

  <v-dialog
      persistent
      :fullscreen="fullscreen"
      max-width="580"
      class="dialog-cancel-order-button"
      v-model="isDialogOpen">

    <!-- (activator button) -->
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" v-if="buttonStyle === 'text'">
        {{ buttonText }}
      </span>
      <v-btn
          v-else-if="buttonStyle === 'menu-item'"
          text
          :width="buttonWidth"
          class="d-flex align-center justify-start"
          color="grey lighten-2"
          v-bind="attrs"
          v-on="on">
        <span>{{ buttonText }}</span>
      </v-btn>
      <!-- Default style -->
      <v-btn
          v-else
          large
          :width="buttonWidth"
          color="red darken-4"
          v-bind="attrs"
          v-on="on">
        <span>{{ buttonText }}</span>
      </v-btn>
    </template>
    <!-- <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" v-if="textOnly">
        Cancel Order
      </span>
      <v-btn
          v-else
          large
          color="red darken-4"
          v-bind="attrs"
          v-on="on">
        <span>Cancel Order</span>
      </v-btn>
    </template> -->

    <!-- (dialog content) -->
    <v-card max-width="580px">
      <!-- Title -->
      <v-card-title class="text-h5">
        <!-- <v-icon large color="red darken-4" class="pr-1">mdi-close</v-icon> -->
        <span class="pr-3">Cancel {{ appName }} Order:</span><span class="order-number">{{ order.order_number }}</span>
      </v-card-title>

      <v-card-text class="px-6 dialog-text">
        <div class="to-from-text mt-3">
          {{ shipper.name }} <v-icon color="orange accent-3">mdi-arrow-right-thin</v-icon> {{ receiver.name }}
        </div>
        <div class="pl-4 pr-10">
          <div class="info-text-main mt-10 d-flex align-center">
            <v-icon color="amber darken-2" class="pr-2">mdi-alert-box-outline</v-icon>
            <span>Canceling an order:</span>
          </div>
          <div class="info-text-sub mt-6">
            <ul>
              <li style="color:#ff9002">
                <span style="color:#bcbbbb">Order will be canceled in the {{ appName }} system only.</span>
              </li>
            </ul>
          </div>
          <div class="info-text-sub mt-4">
            <ul>
              <li style="color:#ff9002">
                <span style="color:#bcbbbb">Notifications will be sent to relevant parties.</span>
              </li>
            </ul>
          </div>
        </div>
      </v-card-text>

      <!-- Actions -->
      <v-card-actions class="mt-4" style="max-width:660px;">
        <v-btn
            large
            plain
            color="primary"
            class="px-5"
            @click="cancel">
          {{ cancelButtonText }}
        </v-btn>
        <v-spacer />
        <v-btn
            large
            color="red darken-4"
            class="mb-2 mr-2 px-5"
            @click="confirm">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: 'DialogCancelOrderButton',

  props: {
    order: {
      type: Object,
      required: true
    },
    buttonText: {
      type: String,
      default: 'Cancel Order',
      required: false
    },
    buttonStyle: {
      type: String,
      default: null,
      required: false
    },
    buttonWidth: {
      type: Number,
      required: false
    },
    fullscreen: {
      type: Boolean,
      default: false,
      required: false
    },
    confirmButtonText: {
      type: String,
      default: 'Confirm Cancel Order',
      required: false
    },
    cancelButtonText: {
      type: String,
      default: 'Close',
      required: false
    }
  },

  data () {
    return {
      isDialogOpen: false,
      notes: null
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    shipper () {
      return this.order.shipper || {}
    },
    receiver () {
      return this.order.receiver || {}
    },
    dispatcherNotes () {
      return this.order.dispatcher_notes?.reschedule
    }
  },

  beforeMount () {
    this.notes = this.dispatcherNotes
  },

  methods: {
    clear () {
      this.notes = null
    },

    cancel () {
      this.clear()
      this.isDialogOpen = false
      this.$emit('canceled', this.order)
    },

    confirm () {
      this.isDialogOpen = false
      this.$emit('confirmed', {
        order: this.order,
        notes: this.notes
      })
    }
  }
}
</script>

<style scoped>
  .v-card {
    border: 1px solid #525252 !important;
  }

  .dialog-text {
    font-size: 18px !important;
  }

  .order-number {
    color: #f7a725;
  }

  .to-from-text {
    font-size: 1.08rem;
  }

  .info-text-main {
    font-size: 1.25rem;
  }

  .info-text-sub {
    font-size: 16px !important;
  }
</style>
